import { render, staticRenderFns } from "./VersionDialog.vue?vue&type=template&id=4e9e7d16&scoped=true&"
import script from "./VersionDialog.vue?vue&type=script&lang=ts&"
export * from "./VersionDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VersionDialog.vue?vue&type=style&index=0&id=4e9e7d16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e7d16",
  null
  
)

export default component.exports